import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-user-template',
  templateUrl: './create-user-template.component.html',
  styleUrls: ['./create-user-template.component.scss']
})
export class CreateUserTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
